if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.prevButton = document.querySelector('#PrevImageSvgBtn');
        this.nextButton = document.querySelector('#NextImageSvgBtn');

        if (!this.elements.thumbnails && (!this.prevButton || !this.nextButton)) return;

        this.elements.viewer.addEventListener('slideChanged', this.onSlideChanged.bind(this));

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
        }

        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.goToPrevSlide.bind(this));
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.goToNextSlide.bind(this));
        }

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        const slides = this.elements.viewer.querySelectorAll('.slider__slide');
        if (slides.length <= 1) {
          if (this.prevButton) this.prevButton.style.display = 'none';
          if (this.nextButton) this.nextButton.style.display = 'none';
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      connectedCallback() {
        this.setInitialActiveThumbnail();
      }

      setInitialActiveThumbnail() {
        if (!this.elements.thumbnails) return;

        const activeMedia = this.elements.viewer.querySelector('.is-active[data-media-id]');
        if (!activeMedia) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${activeMedia.dataset.mediaId}"]`);
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
        }
      }
    connectedCallback() {
        this.setInitialActiveThumbnail();
        this.prioritizeMainImage();
        this.fixVideoThumbnails();
      }

      // Миниатюра видео — кадр на 5-й секунде из самого mp4 (обложка Shopify = первый кадр, часто чёрный).
      // При открытии страницы mp4 не трогаем: в разметке только poster и data-src. Ролик запрашивается
      // после первого действия посетителя и только для миниатюр, которые реально видны (IntersectionObserver).
      // Краулеры (Merchant Center рендерит с таймаутом) не взаимодействуют со страницей — для них запросов к mp4 нет.
      fixVideoThumbnails() {
        const videos = Array.from(this.querySelectorAll('video.thumbnail-video-poster'));
        if (!videos.length) return;

        const seekTo = (v) => {
          const seek = () => {
            try { v.currentTime = Math.min(5, (v.duration || 6) - 0.1); } catch (e) {}
          };
          if (v.readyState >= 1) {
            seek();
          } else {
            v.addEventListener('loadedmetadata', seek, { once: true });
          }
        };

        videos.filter((v) => v.getAttribute('src')).forEach(seekTo);

        const lazy = videos.filter((v) => !v.getAttribute('src') && v.dataset.src);
        if (!lazy.length || this.thumbnailVideosArmed) return;
        this.thumbnailVideosArmed = true;

        const load = (v) => {
          if (v.getAttribute('src')) return;
          v.preload = 'metadata';
          v.src = v.dataset.src;
          seekTo(v);
        };
        const events = ['pointerdown', 'pointermove', 'touchstart', 'keydown', 'wheel', 'scroll'];
        const onFirstAction = () => {
          events.forEach((name) => window.removeEventListener(name, onFirstAction));
          if (!('IntersectionObserver' in window)) {
            lazy.forEach(load);
            return;
          }
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              load(entry.target);
            });
          });
          lazy.forEach((v) => observer.observe(v));
        };
        events.forEach((name) => window.addEventListener(name, onFirstAction, { passive: true }));
      }
      
      prioritizeMainImage() {
        const mainSlide = this.elements.viewer.querySelector('.slider__slide.is-active');
        if (!mainSlide) return;
      
        const mainImage = mainSlide.querySelector('img');
        if (mainImage) {
          mainImage.setAttribute('loading', 'eager');
          mainImage.setAttribute('fetchpriority', 'high');
          if (!mainImage.src && mainImage.dataset.src) {
            mainImage.src = mainImage.dataset.src;
          }
        }
      
        // Придерживать остальные слайды есть смысл, только пока главная картинка грузится: если её нет
        // (первым стоит видео) или она уже загружена, 'load' не придёт и src не вернулся бы никогда.
        if (!mainImage || mainImage.complete) return;

        const otherSlides = this.elements.viewer.querySelectorAll('.slider__slide:not(.is-active)');
        otherSlides.forEach(slide => {
          const img = slide.querySelector('img');
          if (img && img.src) {
            img.dataset.src = img.src;
            img.removeAttribute('src');
            img.setAttribute('loading', 'lazy');
            img.setAttribute('fetchpriority', 'low');
          }
        });

        const restoreOthers = () => {
          otherSlides.forEach(slide => {
            const img = slide.querySelector('img');
            if (img && img.dataset.src && !img.getAttribute('src')) {
              img.src = img.dataset.src;
            }
          });
        };
        mainImage.addEventListener('load', restoreOthers, { once: true });
        mainImage.addEventListener('error', restoreOthers, { once: true });
      }
    setActiveMedia(mediaId, prepend) {
      if (this.isTransitioning) {
        return;
      }
    
      this.isTransitioning = true;
      this.toggleButtons(true);
    
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) {
        this.isTransitioning = false;
        this.toggleButtons(false);
        return;
      }
    
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
    
      activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
    
      const mediaImage = activeMedia.querySelector('img');
      const targetElement = mediaImage || activeMedia; 

      if (mediaImage && !mediaImage.src && mediaImage.dataset.src) {
        mediaImage.setAttribute('loading', 'eager');
        mediaImage.setAttribute('fetchpriority', 'high');
        mediaImage.src = mediaImage.dataset.src;
      }
    
      const completeTransition = () => {
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail) {
            this.setActiveThumbnail(activeThumbnail);
          }
        }
        this.playActiveMedia(activeMedia);
        this.isTransitioning = false;
        this.toggleButtons(false);
      };
    
      targetElement.addEventListener('transitionend', completeTransition, { once: true });
    
      setTimeout(() => {
        if (this.isTransitioning) {
          completeTransition();
        }
      }, 120); 
    }
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        const button = thumbnail.querySelector('button');
        if (!button || button.getAttribute('aria-current') === 'true') return;

        this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
          element.removeAttribute('aria-current');
        });

        button.setAttribute('aria-current', 'true');

        if (!this.elements.thumbnails.isSlideVisible || !this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
        }
      }

      // Из Dawn: при раскладке с миниатюрами список слайдов — не список для скринридера.
      // Метода не было → конструктор падал на вызове → connectedCallback (prioritizeMainImage, fixVideoThumbnails) не запускался.
      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      goToPrevSlide() {
        if (this.isTransitioning) {
          return;
        }
        const slides = this.elements.viewer.querySelectorAll('.slider__slide');
        const activeSlide = this.elements.viewer.querySelector('.slider__slide.is-active');
        if (!activeSlide) return;

        const currentIndex = Array.from(slides).indexOf(activeSlide);
        const prevIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
        const prevSlide = slides[prevIndex];

        this.setActiveMedia(prevSlide.dataset.mediaId, false);
      }

      goToNextSlide() {
        if (this.isTransitioning) {
          return;
        }
        const slides = this.elements.viewer.querySelectorAll('.slider__slide');
        const activeSlide = this.elements.viewer.querySelector('.slider__slide.is-active');
        if (!activeSlide) return;

        const currentIndex = Array.from(slides).indexOf(activeSlide);
        const nextIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
        const nextSlide = slides[nextIndex];

        this.setActiveMedia(nextSlide.dataset.mediaId, false);
      }

      toggleButtons(disabled) {
        if (this.prevButton) this.prevButton.disabled = disabled;
        if (this.nextButton) this.nextButton.disabled = disabled;
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('button').forEach((button) => {
            button.disabled = disabled;
          });
        }
      }
    }
  );
}